import { fetchAsObservable } from "fetcher!sofe";
import { pluck } from "rxjs/operators";

export function getSurveysForClient(clientId) {
  return fetchAsObservable(`/clients/${clientId}/surveys`).pipe(
    pluck("surveys")
  );
}
